export default {
//   baseUrl: "https://dny.jc881.com/", // 测试式:https://dny.jc881.com/
  baseUrl: "http://mdny.ynbzde.com/", // 正式:http://mdny.ynbzde.com/
};
